import { Avatar } from "@mui/material";
// import HtmlTooltip from "../../Tooltip/HtmlTooltip";
import { useState } from "react";
import styled from "styled-components";
import * as md from "../../../styles/mediaQueries";
import { useHeaderData } from "../hooks";
import { avatarStyles } from "../styles/headerData.styled";
import HeaderProfileCard from "./HeaderProfileCard";

const HeaderProfile = () => {
  const { sellerData } = useHeaderData();
  const [show, setShow] = useState(false);

  return (
    <>
      {sellerData?.seller_name && (
        <HeaderProfileContainerStyled>
          <Avatar
            sx={avatarStyles}
            onMouseOver={() => setShow(true)}
            onMouseOut={() => setShow(false)}
          >
            {sellerData?.seller_name &&
              sellerData?.seller_name[0]?.toUpperCase()}
          </Avatar>
          <HeaderProfileDetailsStyled>
            <div className="name">
              {sellerData?.seller_name?.split(" ")?.[0]}
            </div>
            <div>
              {sellerData?.seller_type}
              {sellerData?.seller_type && sellerData?.seller_id && " : "}
              {sellerData?.seller_id}
            </div>
          </HeaderProfileDetailsStyled>
          <HeaderProfileCard sellerData={sellerData} show={show} />
        </HeaderProfileContainerStyled>
      )}
    </>
  );
};

export default HeaderProfile;

export const HeaderProfileContainerStyled = styled.div`
  margin-left: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  ${md.sm} {
    margin-left: 0;
  }
`;
export const HeaderProfileDetailsStyled = styled.div`
  padding-left: 0.5rem;
  width: 100%;
  font-weight: 500;
  color: #404040;
  font-size: 0.65rem;
  .name {
    font-weight: 700;
  }
  ${md.sm} {
    display: none;
    margin: 0;
  }
`;
